import { AlertIcon } from '@approvalmax/ui';
import { Alert, List } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { messages } from './NotificationError.messages';
import { NotificationErrorProps } from './NotificationError.types';

export const NotificationError = memo<NotificationErrorProps>((props) => {
    const { errorMessages } = props;

    return (
        <Alert color='midnight20' invalid startIcon={<AlertIcon size={16} />}>
            {`${errorMessages.length === 1 ? messages.failed : messages.failedPlural}:`}

            <List>
                {errorMessages.map((message) => (
                    <List.Item key={message}>- {message}</List.Item>
                ))}
            </List>
        </Alert>
    );
});

NotificationError.displayName = 'NotificationError';
